const shape = (input: {
  title: string;
  subtitle: string;
  button: string;
  buttonWithCount: string;
  filterLabel: string;
  all: string;
  newLabel: string;
  improved: string;
  fixed: string;
  open: string;
  unread: string;
  loading: string;
  empty: string;
  error: string;
  version: string;
}) => input;

export const productNewsDe = shape({
  title: 'Neuigkeiten',
  subtitle: 'Neue und verbesserte Funktionen, die für Ihre Rolle verfügbar sind.',
  button: 'Neuigkeiten öffnen',
  buttonWithCount: 'Neuigkeiten öffnen, {{count}} ungelesen',
  filterLabel: 'Kategorie filtern',
  all: 'Alle',
  newLabel: 'Neu',
  improved: 'Verbessert',
  fixed: 'Fehler behoben',
  open: 'Funktion öffnen',
  unread: 'Ungelesen',
  loading: 'Neuigkeiten werden geladen',
  empty: 'Für diese Auswahl gibt es keine relevanten Neuigkeiten.',
  error: 'Die Neuigkeiten konnten nicht geladen werden.',
  version: 'Version {{version}}',
});

export const productNewsEn = shape({
  title: 'What’s new',
  subtitle: 'New and improved features available for your role.',
  button: 'Open product news',
  buttonWithCount: 'Open product news, {{count}} unread',
  filterLabel: 'Filter by category',
  all: 'All',
  newLabel: 'New',
  improved: 'Improved',
  fixed: 'Fixed',
  open: 'Open feature',
  unread: 'Unread',
  loading: 'Loading product news',
  empty: 'There is no relevant product news for this selection.',
  error: 'Product news could not be loaded.',
  version: 'Version {{version}}',
});

export const productNewsTr = shape({
  title: 'Yenilikler',
  subtitle: 'Rolünüze sunulan yeni ve iyileştirilmiş özellikler.',
  button: 'Ürün haberlerini aç',
  buttonWithCount: 'Ürün haberlerini aç, {{count}} okunmamış',
  filterLabel: 'Kategoriye göre filtrele',
  all: 'Tümü',
  newLabel: 'Yeni',
  improved: 'İyileştirildi',
  fixed: 'Hata düzeltildi',
  open: 'Özelliği aç',
  unread: 'Okunmamış',
  loading: 'Ürün haberleri yükleniyor',
  empty: 'Bu seçim için ilgili ürün haberi yok.',
  error: 'Ürün haberleri yüklenemedi.',
  version: 'Sürüm {{version}}',
});

export const productNewsFr = shape({
  title: 'Nouveautés',
  subtitle: 'Fonctions nouvelles et améliorées disponibles pour votre rôle.',
  button: 'Ouvrir les actualités produit',
  buttonWithCount: 'Ouvrir les actualités produit, {{count}} non lues',
  filterLabel: 'Filtrer par catégorie',
  all: 'Toutes',
  newLabel: 'Nouveau',
  improved: 'Amélioré',
  fixed: 'Erreur corrigée',
  open: 'Ouvrir la fonction',
  unread: 'Non lu',
  loading: 'Chargement des actualités produit',
  empty: 'Aucune actualité pertinente pour cette sélection.',
  error: 'Les actualités produit n’ont pas pu être chargées.',
  version: 'Version {{version}}',
});

export const productNewsEs = shape({
  title: 'Novedades',
  subtitle: 'Funciones nuevas y mejoradas disponibles para su rol.',
  button: 'Abrir novedades del producto',
  buttonWithCount: 'Abrir novedades del producto, {{count}} sin leer',
  filterLabel: 'Filtrar por categoría',
  all: 'Todas',
  newLabel: 'Nuevo',
  improved: 'Mejorado',
  fixed: 'Error corregido',
  open: 'Abrir función',
  unread: 'Sin leer',
  loading: 'Cargando novedades del producto',
  empty: 'No hay novedades relevantes para esta selección.',
  error: 'No se pudieron cargar las novedades del producto.',
  version: 'Versión {{version}}',
});

export const productNewsRu = shape({
  title: 'Новости',
  subtitle: 'Новые и улучшенные функции, доступные для вашей роли.',
  button: 'Открыть новости продукта',
  buttonWithCount: 'Открыть новости продукта, непрочитанных: {{count}}',
  filterLabel: 'Фильтр по категории',
  all: 'Все',
  newLabel: 'Новое',
  improved: 'Улучшено',
  fixed: 'Ошибка исправлена',
  open: 'Открыть функцию',
  unread: 'Не прочитано',
  loading: 'Загрузка новостей продукта',
  empty: 'Для выбранного фильтра нет актуальных новостей.',
  error: 'Не удалось загрузить новости продукта.',
  version: 'Версия {{version}}',
});
